import { AllowanceClient } from '@frontend/budget/api';
import { UserAllowance } from '@frontend/budget/types';

import { ShopCatalog } from './shop.types';

export interface ShopAllowances {
    product: UserAllowance;
    category: UserAllowance;
}

export const getShopAllowanceCategoryIds = (catalog: ShopCatalog): string[] =>
    [...catalog.breadcrumbs, ...catalog.categories].reduce<string[]>((ids, category) => (ids.includes(category.id) ? ids : [...ids, category.id]), []);

export async function fetchShopAllowances(catalog: ShopCatalog): Promise<ShopAllowances> {
    const productIds = catalog.products.map((product) => product.id);
    const categoryIds = getShopAllowanceCategoryIds(catalog);
    const [product, category] = await Promise.all([
        productIds.length ? AllowanceClient.postGetUserAllowancesV2(productIds) : Promise.resolve<UserAllowance>({}),
        categoryIds.length ? AllowanceClient.postGetUserCategoryAllowances2(categoryIds) : Promise.resolve<UserAllowance>({})
    ]);
    return { product, category };
}
